export const TLCLogger = (function () {
  var isInDebugMode = false;
  var throwRealErrors = false;

  if (window.location.href.indexOf("debug") != -1) {
    isInDebugMode = true;
  } else if (window["svnRevision"] == "dev") {
    isInDebugMode = true;
  }

  var errorStyle = "background-color: #fff; color: #f00;";
  var warningStyle = "background-color: yellow; color: #000;";
  var infoStyle = "background-color: skyblue; color: #000;";

  var currentStyle = "";

  return {
    info: function (_msg) {
      currentStyle = infoStyle;
      TLCLogger.log.apply(this, arguments);
    },
    error: function (_msg) {
      currentStyle = errorStyle;
      TLCLogger.log.apply(this, arguments);
    },
    warn: function (_msg) {
      currentStyle = warningStyle;
      TLCLogger.log.apply(this, arguments);
    },
    log: function (msg) {
      try {
        if (
          (isInDebugMode || currentStyle == errorStyle || msg.stack) &&
          console &&
          console.log
        ) {
          // arguments.callee not supported in strict mode
          // arguments.callee = arguments.callee.caller;

          if (msg.stack) {
            console.log("%c" + msg.message, errorStyle);
            console.log("%c" + msg.stack, errorStyle);
            if (throwRealErrors) {
              throw msg;
            }
          } else if (msg.message) {
            console.log("%c " + msg, errorStyle);
            console.log("%c" + msg.message, errorStyle);
          } else {
            const allArgs = Array.prototype.slice.call(arguments);
            const allArgsLength = allArgs.length;
            if (console.groupCollapsed) {
              console.groupCollapsed("%c" + msg, currentStyle);
              for (let i = 0; i < allArgsLength; i += 1) {
                console.log(allArgs[i]);
              }
              console.trace();
              console.groupEnd();
            } else {
              for (let i = 0; i < allArgsLength; i += 1) {
                console.log(allArgs[i]);
              }
            }
            //						console.log(Array.prototype.slice.call(arguments));
          }
        }
      } catch (err) {
        TLCLogger.error("Error:", err);
      }
      currentStyle = "";
    },
    clear: function () {
      if (isInDebugMode && console && console.clear) {
        console.clear();
      }
    },
    profile: function (title) {
      if (isInDebugMode && console && console.profile) {
        console.profile(title);
      }
    },
    profileEnd: function (title) {
      if (isInDebugMode && console && console.profileEnd) {
        console.profileEnd();
      }
    },
  };
})();
